var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTune = function SvgTune(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tune_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.87,
    d: "M2.625 14.167v1.666h5v-1.666zm0-10v1.666h8.333V4.167zM10.958 17.5v-1.667h6.667v-1.666h-6.667V12.5H9.292v5zm-5-10v1.667H2.625v1.666h3.333V12.5h1.667v-5zm11.667 3.333V9.167H9.292v1.666zm-5-3.333h1.667V5.833h3.333V4.167h-3.333V2.5h-1.667z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tune_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.125 0h20v20h-20z"
  })))));
};
export default SvgTune;